import style from "./loader.module.css"
export const Loader = () => {

    return (
        <span className={style.loader}></span>
    );
};